module.exports = __webpack_public_path__ + "calculator/cummins-generator-calculator/static/media/arrow-left.6b5a05a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-left.svg
// module id = 697
// module chunks = 0